__turbopack_context__.v({
  "copy": "FooterSignUp-module-scss-module__I6kJ_G__copy",
  "fade-in": "FooterSignUp-module-scss-module__I6kJ_G__fade-in",
  "formAndSocial": "FooterSignUp-module-scss-module__I6kJ_G__formAndSocial",
  "header": "FooterSignUp-module-scss-module__I6kJ_G__header",
  "headline": "FooterSignUp-module-scss-module__I6kJ_G__headline",
  "input": "FooterSignUp-module-scss-module__I6kJ_G__input",
  "inputSuccess": "FooterSignUp-module-scss-module__I6kJ_G__inputSuccess",
  "inputWrapper": "FooterSignUp-module-scss-module__I6kJ_G__inputWrapper",
  "joinError": "FooterSignUp-module-scss-module__I6kJ_G__joinError",
  "reCaptchaLegal": "FooterSignUp-module-scss-module__I6kJ_G__reCaptchaLegal",
  "root": "FooterSignUp-module-scss-module__I6kJ_G__root",
  "socialLinks": "FooterSignUp-module-scss-module__I6kJ_G__socialLinks",
  "spinner": "FooterSignUp-module-scss-module__I6kJ_G__spinner",
  "submitButton": "FooterSignUp-module-scss-module__I6kJ_G__submitButton",
});
